export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "carrus-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "carrus-themeWrapLive" */'./LiveThemeImporter'),
  },
};
